export default "__VITE_ASSET__BOEqgXsw__"